import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from './config/api';

// 1. Import Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// 2. Import Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Cart from './pages/Cart';
import Shop from './pages/shop'; 
import Distributor from './pages/Distributor';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import AdminDashboard from './pages/AdminDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import ProductDetails from './pages/ProductDetails';
import About from './pages/About';
import RefundPolicy from './pages/RefundPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import StoreFinder from './pages/StoreFinder';
import OrganicAtta from './pages/organic';
import WheatIngredient from './pages/WheatIngredient';
import OrderHistory from './pages/OrderHistory'; // <--- ADDED THIS

// 3. Import Context Providers
import { CartProvider } from './context/CartContext';
import { AuthProvider, useAuth } from './context/AuthContext'; 

// --- GLOBAL API CONFIGURATION ---
// Uses environment variable REACT_APP_API_URL or defaults to Hostinger backend
axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = false; 

// --- HELPER COMPONENT FOR LAYOUT LOGIC ---
// This component sits inside the Router, so useLocation works here
const ProtectedAdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const isAdmin = user && (user.role === 'admin' || user.isAdmin === true);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Checking admin access...
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={{ from: "/admin" }} replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
};

const AppContent = () => {
  const location = useLocation();

  // Check if the current route is the admin panel
  // used .startsWith in case you have /admin/products, /admin/orders etc.
  const isAdminRoute = location.pathname.startsWith('/admin'); 

  return (
    <div className="min-h-screen bg-kesvi-bg font-sans selection:bg-kesvi-accent selection:text-white">
      <ScrollToTop />
      {/* Only show Navbar if NOT on admin page */}
      {!isAdminRoute && <Navbar />}

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/distributor" element={<Distributor />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/product/:slug" element={<ProductDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/store-finder" element={<StoreFinder />} />
          <Route path="/organic-atta" element={<OrganicAtta />} />
          <Route path="/wheat-ingredients" element={<WheatIngredient />} />
          <Route path="/orders" element={<OrderHistory />} /> {/* <--- ADDED THIS */}
        </Routes>
      </main>

      {/* Only show Footer if NOT on admin page */}
      {!isAdminRoute && <Footer />}
    </div>
  );
};

// --- MAIN APP COMPONENT ---
function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <AppContent />
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
